import { useState } from "react";

const MAX_VISIBLE = 3;

const ArrayListField = ({ values }) => {
  const [showAll, setShowAll] = useState(false);

  const items = values.filter((v) => v && typeof v === "string" && v.trim() !== "");
  if (items.length === 0) return <span>NA</span>;

  const visible = showAll ? items : items.slice(0, MAX_VISIBLE);

  return (
    <span className="tw-flex tw-flex-col tw-gap-1">
      {visible.map((item, idx) => {
        const isTruncated = item.length > 50;
        return (
          <span key={idx} className="text-capitalize tw-block">
            {isTruncated ? item.slice(0, 50) : item}
            {isTruncated && "..."}
          </span>
        );
      })}
      {items.length > MAX_VISIBLE && (
        <a
          className="btn-link trademo-link"
          style={{ fontSize: "12px", marginTop: "2px" }}
          onClick={(e) => {
            e.stopPropagation();
            setShowAll((prev) => !prev);
          }}>
          {showAll ? "Show less" : `+${items.length - MAX_VISIBLE} more`}
        </a>
      )}
    </span>
  );
};

export default ArrayListField;
